import React from 'react';
import styles from './index.less';
import SlideModel from '@src/slide/domain/ui-model/element-modeles/slide-model';
import classNames from 'classnames';
import ScaleSlide from '@editor/src/page/index/components/canvas/scale-slide';
import { RenderPostionType } from '@src/js/constant';
import Checkbox from '@tencent/dui/lib/components/Checkbox';
import { TaskPriority } from '@src/slide/infrastructure/module/dependent/taskManager';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { reaction } from 'mobx';

interface IPreviewSlideContainerProps {
    // 列数，优先横向排列
    colNumber: number;
    // 要展示的slides
    slideList: ISlideModel[];
    // 竖向间距
    slideVerticalMargin?: number;
    // slide是否需要选中态
    needSelectedState?: boolean;
    // 选中的列表
    selectList?: boolean[];
    showBorder?: boolean;
    originSlideWidth?: number;
    originSlideHeight?: number;
    // 选中态变化的回调
    onSelect?(selectedList: boolean[]): void;
}

export interface IPreviewSlideContainerState {
    selectedList: boolean[];
    scaleSlideWidth: number;
    scaleSlideHeight: number;
}

const DEFAULT_SLIDE_WIDTH = 482;
const DEFAULT_SLIDE_HEIGHT = 268;

/**
 * 预览列表
 */
export class PreviewSlideContainer extends React.Component<IPreviewSlideContainerProps, IPreviewSlideContainerState> {
    private wrapperRef;
    private reaction;
    public constructor(props: IPreviewSlideContainerProps) {
        super(props);
        const {
            slideList,
            selectList,
            originSlideWidth = DEFAULT_SLIDE_WIDTH,
            originSlideHeight = DEFAULT_SLIDE_HEIGHT,
        } = this.props;
        this.state = {
            selectedList: selectList || Array(slideList?.length || 0).fill(false),
            scaleSlideWidth: DEFAULT_SLIDE_WIDTH,
            scaleSlideHeight: Math.floor(DEFAULT_SLIDE_WIDTH * (originSlideHeight / originSlideWidth)),
        };
        this.wrapperRef = null;
        this.initReaction();
    }

    public componentDidMount(): void {
        this.convertVisibleSlide();
    }

    public componentWillUnmount() {
        this.reaction?.();
    }

    public render() {
        const {
            slideList,
            slideVerticalMargin,
            needSelectedState,
            selectList,
        } = this.props;
        return <div
            className={styles['preview-slide-container']}
            onScroll={this.handleContainerScroll.bind(this)}
            style={{
                width: '100%',
                height: '100%',
            }}
            ref={((el) => {
                this.wrapperRef = el;
            })}
        >
            <div className={styles['preview-slide-list-container']}>
                {
                    slideList?.map((slideModel: SlideModel, index) => (
                        <div className={classNames({
                            [styles['preview-slide-item']]: true,
                            [styles['selected-scale']]: true,
                            [styles['show-border']]: !!this.props.showBorder,
                        })}
                        style={{
                            width: `${this.state.scaleSlideWidth}px`,
                            height: `${this.state.scaleSlideHeight}px`,
                        }}
                        onClick={() => {
                            this.selectSlide(index);
                        }}
                        key={slideModel.key}
                        >
                            <ScaleSlide
                                width={this.state.scaleSlideWidth - 2}
                                height={this.state.scaleSlideHeight - 1}
                                isShown={true}
                                slideModel={slideModel}
                                buildRenderTreeAsync={false}
                                shouldUpdate={true}
                                fromScale={0}
                                region={RenderPostionType.PAGINGSELECTION}
                                isTemplate={false}
                            />
                            {
                                needSelectedState && <div className={styles['check-wrapper']}>
                                    <Checkbox
                                        onChange={() => {
                                            this.selectSlide(index);
                                        }}
                                        checked={selectList ? selectList[index] : this.state.selectedList[index]} />
                                </div>
                            }
                        </div>
                    ))
                }
            </div>
        </div>;
    }

    private convertVisibleSlide() {
        const { slideList, slideVerticalMargin } = this.props;
        slideList?.forEach((slideModel: SlideModel, index) => {
            const rowNumberBeforeSlide = Math.floor(index / this.props.colNumber);
            const heightBeforeSlide = rowNumberBeforeSlide * (this.state.scaleSlideHeight + (slideVerticalMargin || 0));
            const containerHeight = this.wrapperRef.getBoundingClientRect().height;
            if (heightBeforeSlide - this.wrapperRef.scrollTop > containerHeight) {
                return;
            }
            if (!slideModel.childrenConverted) {
                slideModel.startConvertChildrenTask(TaskPriority.HIGH);
            }
        });
    }

    private handleContainerScroll() {
        this.convertVisibleSlide();
    }

    private selectSlide(index: number): void {
        if (this.props.onSelect) {
            const newSelectList = this.state.selectedList;
            newSelectList[index] = !newSelectList[index];
            this.setState({
                selectedList: newSelectList,
            });
            this.props.onSelect?.(newSelectList);
        }
    }

    private initReaction() {
        this.reaction = reaction(() => this.props.slideList.length, () => {
            this.convertVisibleSlide();
            this.forceUpdate();
        });
    }
}
